import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Heart } from 'lucide-react';

const LOGO = "/logo.png";

export default function Footer() {
    return (
        <footer className="bg-cp-brand text-white" data-testid="main-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
                    {/* Brand */}
                    <div className="lg:col-span-1">
                        <Link to="/" className="inline-flex items-center gap-2 mb-4">
                            <img src={LOGO} alt="CloudPet" className="h-10 w-auto brightness-0 invert" />
                        </Link>
                        <p className="text-[#DCE9FF] text-sm leading-relaxed">
                            Tu tienda online de confianza para juguetes, alimentos y accesorios para mascotas en Buenos Aires.
                        </p>
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-widest">Tienda</h4>
                        <ul className="space-y-2.5">
                            {[
                                { to: '/productos?category=juguetes-perros', label: 'Juguetes para Perros' },
                                { to: '/productos?category=juguetes-gatos', label: 'Juguetes para Gatos' },
                                { to: '/productos?category=alimentos', label: 'Alimentos' },
                                { to: '/productos?category=accesorios', label: 'Accesorios' },
                            ].map(link => (
                                <li key={link.to}>
                                    <Link to={link.to} className="text-[#DCE9FF] hover:text-cp-primary text-sm transition-colors">
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Help */}
                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-widest">Ayuda</h4>
                        <ul className="space-y-2.5">
                            <li><Link to="/productos" className="text-[#DCE9FF] hover:text-cp-primary text-sm transition-colors">Todos los Productos</Link></li>
                            <li><Link to="/carrito" className="text-[#DCE9FF] hover:text-cp-primary text-sm transition-colors">Mi Carrito</Link></li>
                            <li><Link to="/admin/login" className="text-[#DCE9FF] hover:text-cp-primary text-sm transition-colors">Admin</Link></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-widest">Contacto</h4>
                        <ul className="space-y-3">
                            <li className="flex items-start gap-2.5">
                                <MapPin size={16} className="text-cp-primary mt-0.5 shrink-0" />
                                <span className="text-[#DCE9FF] text-sm">Buenos Aires, Argentina</span>
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Phone size={16} className="text-cp-primary shrink-0" />
                                <span className="text-[#DCE9FF] text-sm">WhatsApp</span>
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Mail size={16} className="text-cp-primary shrink-0" />
                                <span className="text-[#DCE9FF] text-sm">info@cloudpet.com.ar</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-white/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-[#DCE9FF] text-sm">
                        &copy; {new Date().getFullYear()} CloudPet. Todos los derechos reservados.
                    </p>
                    <p className="text-[#DCE9FF] text-xs flex items-center gap-1">
                        Hecho con <Heart size={12} className="text-cp-primary" /> para las mascotas
                    </p>
                </div>
            </div>
        </footer>
    );
}
